import { render } from "./bead.vue?vue&type=template&id=64252a8e&ts=true"
import script from "./bead.vue?vue&type=script&lang=ts"
export * from "./bead.vue?vue&type=script&lang=ts"

import "./bead.vue?vue&type=style&index=0&id=64252a8e&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__